import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { FaUpload } from "react-icons/fa";
import "./UploadImages.css";
import {
  Button,
  CircularProgress,
  FormControl,
  MenuItem,
  Select,
  Snackbar,
  Alert,
} from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";

const UploadImages = () => {
  const location = useLocation();
  const receivedData = location.state?.data || [];
  console.log(receivedData);

  const [selectedFile, setSelectedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [result, setResult] = useState(null);
  const [recommendedProducts, setRecommendedProducts] = useState([]);
  const [recommendationType, setRecommendationType] = useState("All");
  const [analizeLoader, setanalizeLoader] = useState(false);
  const [recommendedDropdownData, setrecommendedDropdownData] = useState("");
  const [recommendedProductsLoader, setrecommendedProductsLoader] =
    useState(false);
  const [faveStatus, setFaveStatus] = useState({});
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [accessToken, setAccessToken] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const storedAccessToken = localStorage.getItem("AccessToken");
    if (storedAccessToken) setAccessToken(storedAccessToken);
  }, []);

  useEffect(() => {
    if (receivedData.length > 0) {
      setRecommendedProducts(receivedData);
    }
  }, [receivedData]);

  const handleChange = (event) => {
    // console.log(event);
    setrecommendedDropdownData(event.target.value);
    // setRecommendationType(selectedType);
    // fetchRecommendations(selectedType);
  };

  // console.log(age)

  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   setSelectedFile(file);
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setPreviewImage(reader.result);
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUpload = useCallback(async () => {
    if (!selectedFile) {
      setSnackbarMessage("Please select an image before uploading.");
      setSnackbarSeverity("warning");
      setOpenSnackbar(true);
      return;
    }
    setanalizeLoader(true);
    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/recommendation/detect_skin_tone/`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      console.log("response--", response.data);

      if (response.data.status === "success") {
        setResult(response.data);
        setRecommendedProducts([]);
        setOpenSnackbar(false);
        setSnackbarMessage("");
      } else if (response.data.status === "failed") {
        console.log("Failed response received");
        console.log("Snackbar about to be shown:", response.data.detail);
        setSnackbarMessage(
          "No face detected.Please upload a image with clearly visible face."
        );
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
        console.log("complete API");
      }
      // setResult(response.data);
      // setRecommendedProducts([]);
      setanalizeLoader(false);
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  }, [selectedFile]);

  useEffect(() => {
    if (selectedFile && receivedData.length === 0) {
      console.log("------------", selectedFile);
      handleUpload();
    }
  }, [selectedFile, handleUpload]);
  useEffect(() => {
    if (recommendationType && receivedData.length === 0) {
      fetchRecommendations();
    }
  }, [recommendationType]);

  const fetchRecommendations = async () => {
    // if (!result?.hex_color) {
    //   alert("Skin tone not detected yet!");
    //   return;
    // }
    setRecommendedProducts([]);
    setrecommendedProductsLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/recommendation/recommend_by_color/`,

        {
          hex_color: result.hex_color,
          recommendation_type: recommendationType,
        },
        { headers: { "Content-Type": "application/json" } }
      );
      console.log("API Response:", response.data);
      setrecommendedProductsLoader(false);
      if (response.data.recommended_products?.length > 0) {
        console.log("Data", response.data.recommended_products);
        setRecommendedProducts(response.data.recommended_products);
      } else {
        setRecommendedProducts([]);
      }
    } catch (error) {
      console.error("Error fetching recommendations:", error);
    } finally {
      setrecommendedProductsLoader(false);
    }
  };
  
  useEffect(() => {
    document.body.classList.add("hide-scrollbar");

    return () => {
      document.body.classList.remove("hide-scrollbar"); // cleanup when leaving page
    };
  }, []);
  const handleAddToFavourites = async (item) => {
    try {
      setFaveStatus((prev) => ({ ...prev, [item.ID]: "loading" }));
      const userID = localStorage.getItem("userId");
      if (!userID) {
        setFaveStatus((prev) => ({ ...prev, [item.ID]: "failed" }));
        setSnackbarMessage(
          "You need to be logged in to perform this action.Please login!"
        );
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
        console.error("Token is missing");
        return;
      }
      console.log("token", userID);
      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/cart/add?userID=${userID}`,
        {
          product_id: item.ID,
          quantity: 1,
        }
      );
      console.log("API Response:", response.data);
      setFaveStatus((prev) => ({ ...prev, [item.ID]: "added" }));
      setSnackbarMessage("Added to favourites successfully!");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);
    } catch (error) {
      console.error("Error adding to favourites:", error);
      setSnackbarMessage("Something went wrong. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      setFaveStatus((prev) => ({ ...prev, [item.ID]: "idle" }));
    }
  };

  console.log("recommendedProducts : ", recommendedProducts.length);
  console.log("receivedData : ", receivedData.length);

  return (
    <>
      <div className="upload-container">
        {receivedData.length === 0 ? (
          <>
            <h1 className="title">skin tone detector</h1>
            <p className="subtitle">
              upload an image or take a photo to detect your skin tone.
            </p>
            <div className="button-group">
              <label className="upload-button">
                <FaUpload className="icon" />
                <span style={{ fontFamily: "Roboto" }}>upload image</span>
                <input
                  type="file"
                  accept="image/*"
                  className="hidden"
                  onChange={handleFileChange}
                />
              </label>

              {/* <button
          className="photo-button"
          onClick={() => document.querySelector('input[type="file"]').click()}
        >
          <FaCamera className="icon" /> Take Photo
        </button> */}
            </div>
            {selectedFile && (
              <div className="preview-container">
                <img
                  src={previewImage}
                  alt="Preview"
                  className="preview-image"
                />
                {analizeLoader ? (
                  <Button
                    loading={analizeLoader}
                    variant="outlined"
                    loadingPosition="end"
                    className="analyze-button"
                    sx={{ fontFamily: "niavhFont", textTransform: "lowercase" }}
                    style={{ color: "white" }}
                  >
                    analyzing...
                  </Button>
                ) : result ? (
                  <Button
                    variant="outlined"
                    className="analyze-button"
                    sx={{ fontFamily: "niavhFont", textTransform: "lowercase" }}
                  >
                    analyzed ✔
                  </Button>
                ) : (
                  <Button
                    variant="outlined"
                    className="analyze-button"
                    sx={{ fontFamily: "niavhFont", textTransform: "lowercase" }}
                  >
                    analyze image
                  </Button>
                )}
              </div>
            )}
            {/* <div
          className="dropdown"
          style={{
            // backgroundColor: "red",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "20px",
          }}
        >
          <h2>Detected Skin Tone: </h2>
          <h2>Hex Color:</h2>
          
          <FormControl sx={{ m: 1, minWidth: 220, overflow: "hidden" }}>
            <Select
              value={age}
              onChange={handleChange}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {["Matching", "Balanced", "Contrast"].map((item, index) => (
                <MenuItem
                  // value={10}
                  key={index}
                  onClick={() => {
                    setRecommendationType(item);
                    fetchRecommendations();
                  }}
                >
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div> */}
            {result && (
              <div className="result-container">
                <div
                  className="dropdown"
                  style={{
                    // backgroundColor: "red",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "20px",
                  }}
                >
                  <h2>detected skin tone: {result.skin_tone}</h2>
                  {/* <h2>hex color:{result.hex_color}</h2> */}
                  <FormControl sx={{ m: 1, minWidth: 220 }}>
                    <Select
                      value={recommendedDropdownData}
                      onChange={handleChange}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      sx={{
                        fontFamily: "Roboto",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "gray", // default border color
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "black", // border on hover
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "black", // border when active (focused)
                        },
                      }}
                    >
                      <MenuItem value="">
                        <em>recommended products</em>
                      </MenuItem>
                      {["matching", "balanced", "contrast"].map(
                        (item, index) => (
                          <MenuItem
                            value={item}
                            sx={{ fontFamily: "Roboto" }}
                            // value={10}
                            key={index}
                            onClick={() => {
                              setrecommendedProductsLoader(true);
                              setRecommendationType(item);
                              // fetchRecommendations();
                            }}
                          >
                            {item}
                          </MenuItem>
                        )
                      )}
                    </Select>
                  </FormControl>
                </div>
                {recommendedProductsLoader && (
                  <CircularProgress
                    color="inherit"
                    className="spinnerOfRecomendedProducts"
                  />
                )}
                {/* <h2>Detected Skin Tone: {result.skin_tone}</h2>
          <h2>Hex Color:{result.hex_color}</h2>
          <div className="dropdown">
            <button className="recommend-button">
              {recommendationType === "All"
                ? "Recommend Products"
                : recommendationType}
              <span className="arrow-down"></span>
            </button>

            <div className="dropdown-content">
              <div
                onClick={() => {
                  setRecommendationType("All");
                  fetchRecommendations();
                }}
              >
                Recommended Products
              </div>
              <div
                onClick={() => {
                  setRecommendationType("Matching");
                  fetchRecommendations();
                }}
              >
                Matching
              </div>
              <div
                onClick={() => {
                  setRecommendationType("Balanced");
                  fetchRecommendations();
                }}
              >
                Balanced
              </div>
              <div
                onClick={() => {
                  setRecommendationType("Contrast");
                  fetchRecommendations();
                }}
              >
                Contrast
              </div>
            </div> 
          </div>*/}

                {/* <button onClick={fetchRecommendations} className="recommend-button">
            Recommend Products
          </button> */}
                {recommendedProducts.length > 0 && (
                  <ul>
                    {recommendedProducts.map((item, index) => (
                      <li key={index} className="product-item">
                        <h3>
                          {item.ProductName} -{" "}
                          <a
                            href={item.URL}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {item.BrandName}
                          </a>
                        </h3>
                        {item.image_base64 && (
                          <img
                            src={`data:image/png;base64,${item.image_base64}`}
                            alt={item.ProductName}
                            width="150"
                          />
                        )}
                        <div className="product-actions">
                          <Button
                            variant="outlined"
                            sx={{
                              fontFamily: "niavhFont",
                              textTransform: "lowercase",
                              marginRight: 2,
                              minWidth: 180,
                            }}
                            onClick={() => handleAddToFavourites(item)}
                            disabled={faveStatus[item.ID] === "loading"}
                          >
                            {faveStatus[item.ID] === "loading" ? (
                              <>
                                <CircularProgress
                                  size={16}
                                  sx={{ mr: 1 }}
                                  color="inherit"
                                />
                                Adding...
                              </>
                            ) : faveStatus[item.ID] === "added" ? (
                              "✅ Successfully Added"
                            ) : (
                              "❤️ Add to Favourites"
                            )}
                          </Button>
                          <Snackbar
                            open={openSnackbar}
                            autoHideDuration={20000}
                            onClose={() => setOpenSnackbar(false)}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "right",
                            }}
                          >
                            <Alert
                              onClose={() => setOpenSnackbar(false)}
                              severity={snackbarSeverity}
                              variant="filled"
                              action={
                                snackbarMessage.includes(
                                  "Added to favourites"
                                ) && (
                                  <Button
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setOpenSnackbar(false);
                                      navigate(`/${accessToken}/favourites`);
                                    }}
                                    className="go-to-fav-btn"
                                  >
                                    <ArrowRightAltIcon />
                                  </Button>
                                )
                              }
                            >
                              {snackbarMessage}
                            </Alert>
                          </Snackbar>
                          <a
                            href={item.URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none" }}
                          >
                            <Button
                              variant="contained"
                              sx={{
                                fontFamily: "niavhFont",
                                textTransform: "lowercase",
                              }}
                            >
                              Buy Now
                            </Button>
                          </a>
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}
          </>
        ) : (
          <>
            {receivedData.length > 0 && recommendedProducts.length > 0 && (
              <ul>
                {recommendedProducts.map((item, index) => (
                  <li key={index} className="product-item">
                    <h3>
                      {item.product_name} -{" "}
                      <a
                        href={item.URL}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.brand_name}
                      </a>
                    </h3>
                    {item.image && (
                      <img
                        src={`data:image/png;base64,${item.image}`}
                        alt={item.product_name}
                        width="150"
                      />
                    )}
                    <div className="product-actions">
                      <a
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none" }}
                      >
                        <Button
                          variant="contained"
                          sx={{
                            fontFamily: "Roboto",
                            textTransform: "lowercase",
                          }}
                        >
                          Buy Now
                        </Button>
                      </a>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default UploadImages;
